<template>
  <div class="console demo-layout">
    <div class="demo-layout__banner">
      <span class="label">Public Demo</span>
      <p>This is a recorded, read-only walkthrough built from frozen data. Nothing on these routes mutates state.</p>
    </div>

    <nav class="console__tabs" aria-label="Demo">
      <router-link
        v-for="tab in tabs"
        :key="tab.label"
        :to="tab.to"
        class="console__tab"
        :class="{ 'console__tab--active': isTabActive(tab) }"
      >
        {{ tab.label }}
      </router-link>
    </nav>

    <div class="console__content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { demoJobId, demoWorkspaceId } from '@/config/demo'

const route = useRoute()

const tabs = [
  { label: 'Walkthrough', to: '/demo', match: '/demo' },
  { label: 'Workspace', to: `/demo/workspaces/${demoWorkspaceId}`, match: '/demo/workspaces/' },
  { label: 'Run', to: `/demo/jobs/${demoJobId}`, match: '/demo/jobs/' },
]

function isTabActive(tab) {
  if (tab.to === '/demo') return route.path === '/demo'
  return route.path.startsWith(tab.match)
}
</script>

<style src="@/styles/console.css"></style>

<style scoped>
.demo-layout__banner {
  margin-bottom: 18px;
  padding: 18px 20px;
  border: 1px solid var(--shell-border);
  background: var(--shell-surface);
  box-shadow: var(--shell-shadow);
}

.demo-layout__banner p {
  margin: 0;
  color: var(--shell-text-muted);
  line-height: 1.7;
}
</style>
